<template>
  <SoftwareFormEditor form-name="modifySoftwareForm" modification />
</template>

<script>
import SoftwareFormEditor from "./SoftwareFormEditor.vue";

export default {
  name: "ModifySoftwareForm",
  components: { SoftwareFormEditor }
};
</script>
